import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import styled from 'styled-components';
import { KB_RELATED_ARTICLE_CLICKED } from '../../constants/PostMessageTypes';
import hashCode from '../../utils/hashCode';
import { useKBArticle } from '../kbArticleSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const ArticleWrapper = styled.div.withConfig({
  displayName: "KBArticle__ArticleWrapper",
  componentId: "rytgbb-0"
})(["width:100%;height:100%;overflow-y:scroll;"]);
function KBArticle() {
  const kbArticle = useKBArticle();
  const {
    hubSpotContentId,
    hubSpotContentTextFragment
  } = kbArticle;
  const fullUrl = getFullUrl('app-api');
  const portalId = PortalIdParser.get();
  const anchorName = hubSpotContentTextFragment ? `aicitation-${hashCode(hubSpotContentTextFragment)}` : `${portalId}${hubSpotContentId}`;
  const handleIframeOnload = () => {
    var _iframe$contentWindow;
    const iframe = document.querySelector('#kb-article-iframe');
    const iframeDocument = (_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 ? void 0 : _iframe$contentWindow.document;
    if (iframeDocument) {
      const relatedArticlesContainer = iframeDocument.querySelector('#kb-related-articles-container');
      if (relatedArticlesContainer && relatedArticlesContainer !== null && relatedArticlesContainer !== void 0 && relatedArticlesContainer.children.length) {
        relatedArticlesContainer.addEventListener('click', event => {
          const target = event.target;
          // Only do when the target is an anchor and has a data-article-id attribute
          if (target.nodeName === 'A' && target.dataset.articleId) {
            event.preventDefault();
            postMessage(JSON.stringify({
              type: KB_RELATED_ARTICLE_CLICKED,
              data: {
                hashedLink: target.href,
                hubSpotContentId: target.dataset.articleId
              }
            }));
          }
        });
      }
    }
  };
  return /*#__PURE__*/_jsx(ArticleWrapper, {
    children: /*#__PURE__*/_jsx("iframe", {
      src: `${fullUrl}/conversations/assistants/v1/content-embed?hubSpotContentType=KB_ARTICLE&portalId=${portalId}&hubSpotContentId=${hubSpotContentId}&contentTextFragment=${hubSpotContentTextFragment}&anchorName=${anchorName}#${anchorName}`,
      style: {
        width: '100%',
        height: '100%',
        border: 'none'
      },
      onLoad: handleIframeOnload,
      id: 'kb-article-iframe'
    })
  });
}
KBArticle.displayName = 'KBArticle';
export default KBArticle;